import { IconButton } from "@mui/material";
import { Box, styled } from "@mui/system";

export const PopupHeader =styled(Box)({
  padding: '20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: '#ccd0e8',
  position: 'sticky',
  top: '0',
  zIndex: 1,
  "& h2 ": {
    marginBottom: "0",
  },
});
export const PopupBody = styled(Box)({
  padding: " 20px 20px 20px 20px",
  width:'50%',
  height:'70%',
  margin: 'auto',
  "&:focus-visible ": {
    outline: "none",
  },
});
export const PopupButton = styled(IconButton)({
  minWidth:'24px',
  width:'24px',
  height:'24px',
  borderRadius:'50%',
  backgroundColor:'rgba(255, 255, 255, 0.5)',
  "& svg": {
   width:'12px',
  height:'12px',
 },
 });
 export const Fragment =styled(Box)({
  backgroundColor: '#fff',
  overflowY: 'auto',
  marginBottom: '60px'
});
export const FormTitle = styled(Box)({
  fontWeight: 'bold',
  fontSize: '18px',
  marginBottom: '20px',
  marginLeft: '25px',
});

export const FormContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '50px',
  flexDirection: 'column',
  alignItems: 'center'
});

export const FieldContainer = styled(Box)({
  width: '325px',
  margin: '5px 25px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  "& .MuiFormLabel-root": {
    marginBottom: '9px',
  },
  "& .MuiInputBase-root": {
    minWidth: '100%',
    minHeight: '30px',
    border: '1px solid #b2b9dc',
    borderRadius: '4px',
    "& input": {
      padding: '0px 10px',
    }
  },
  "& .MuiRadio-root" :{
    padding:'0 9px'
  }
});

export const ButtonsContainer = styled(Box)({
  margin: '0 25px',
  textAlign: 'center',
  "& .MuiButtonBase-root": {
    marginRight: '18px',
    height: '26px',
    fontSize: '12px',
  },
});

export const TextAreaContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  borderBottom: '0',
  justifyContent: 'space-between',
  margin: '15px 25px',
  "& .MuiInputBase-root": {
    background: '#f2f4ff',
    minWidth: '100%',
    minHeight: '200px',
  },
  "& .MuiFormLabel-root": {
    minHeight: '50px',
    textWrap: 'wrap',
  },
  "& textarea": {
    minWidth: '100%',
    minHeight: '30px',
    border: '1px solid #b2b9dc',
    borderRadius: '4px',
    resize: 'none',
    padding: '10px',
  }
});

export const SectionContainer = styled(Box)({
    borderRadius: '5px',
    marginBottom: '20px',
    display:'grid',   
    gridTemplateColumns: '1fr 1fr'
});

export const SectionTitle = styled(Box)({
    fontSize: '15px',
    color: '#5c088c',
    textTransform: 'uppercase',
    fontWeight: 'bold'
})

export const SectionWarning = styled(Box)({
    fontSize: '15px',
    color: '#990000',
    textTransform: 'uppercase',
    margin: '5px 50px',
    textAlign: 'center',
})
